import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Input/sgds-input";
import { register } from "../../utils/ce-registry";

register("sgds-input", Component);

export default createComponent({
  react: React,
  tagName: "sgds-input",
  elementClass: Component,
  events: {
    onSgdsChange: "sgds-change",
    onSgdsInput: "sgds-input",
    onSgdsFocus: "sgds-focus",
    onSgdsBlur: "sgds-blur",
    onSgdsInvalid: "sgds-invalid",
    onSgdsValid: "sgds-valid"
  }
});
